"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ReduxGlobalStateKeys_1 = require("./ReduxGlobalStateKeys");
/**
 * 初始化全局变量保存Redux管理数据
 * @param getGlobalState 获取全局对象用于保存数据
 * @param defineGlobalState 定义全局对象保存数据，当前方法会调用几次defineGlobalState传入key初始化数据结构
 */
exports.defineReduxProvider = function (getGlobalState, defineGlobalState) {
    var dataID = ReduxGlobalStateKeys_1.REDUX_GLOBAL_STATE_KEY;
    var listenerID = ReduxGlobalStateKeys_1.REDUX_GLOBAL_LISTEN_KEY;
    var reduxState = {
        listener: null,
        state: null
    };
    if (!getGlobalState(dataID)) {
        reduxState.listener = {};
        reduxState.state = {};
        defineGlobalState(dataID, reduxState.state); // 保存单纯的state数据
        defineGlobalState(listenerID, reduxState.listener); // 保存subscribe挂载对象，在数据变化时触发组件的Change事件
        dataID = null;
        listenerID = null;
    }
    else {
        reduxState.state = getGlobalState(dataID);
        reduxState.listener = getGlobalState(listenerID);
    }
    return reduxState;
};
